import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useLanguage } from "@/contexts/LanguageContext";
import { useToast } from "@/hooks/use-toast";

interface SignOutButtonProps {
  variant?: "ghost" | "outline" | "default";
  size?: "sm" | "default" | "icon";
  showLabel?: boolean;
  className?: string;
}

export function SignOutButton({
  variant = "ghost",
  size = "sm",
  showLabel = true,
  className,
}: SignOutButtonProps) {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { language } = useLanguage();
  const { toast } = useToast();

  const label = language === "fr" ? "Déconnexion" : "Sign out";

  const handleLogout = async () => {
    try {
      await logout();
      toast({
        title: language === "fr" ? "Déconnecté" : "Logged out",
        description:
          language === "fr"
            ? "Vous avez été déconnecté avec succès."
            : "You've been successfully logged out.",
      });
      navigate("/login");
    } catch {
      toast({
        title: language === "fr" ? "Erreur" : "Error",
        description:
          language === "fr"
            ? "Échec de la déconnexion. Veuillez réessayer."
            : "Failed to log out. Please try again.",
        variant: "destructive",
      });
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleLogout}
      className={`gap-2 ${className ?? ""}`}
      title={label}
      aria-label={label}
    >
      <LogOut className="h-4 w-4" />
      {showLabel && size !== "icon" && <span>{label}</span>}
    </Button>
  );
}

export default SignOutButton;
